export enum OrderERPCreationMode {
  OnOrderStart = "OnOrderStart",
  OnSpecifiedWorkflowStepRunning = "OnSpecifiedWorkflowStepRunning",
  OnSpecifiedWorkflowStepCompleted = "OnSpecifiedWorkflowStepCompleted",
  OnSpecifiedWorkflowStepFailed = "OnSpecifiedWorkflowStepFailed",
}
